import { render, staticRenderFns } from "./DetailData.vue?vue&type=template&id=4158e518&"
import script from "./DetailData.vue?vue&type=script&lang=js&"
export * from "./DetailData.vue?vue&type=script&lang=js&"
import style0 from "./DetailData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports